"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenMarketDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const fetch_utils_1 = require("../../fetch.utils");
const GetTokenPriceGrouped_1 = __importDefault(require("../../get/GetTokenPriceGrouped"));
const GetTokenPriceGroupedLive_1 = __importDefault(require("../../get/GetTokenPriceGroupedLive"));
const Dataset_1 = require("../Dataset");
class TokenMarketDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.tradeToken = (this.sendRequest(interfaces_1.WEN_FUNC.tradeToken));
        this.getTokenPrice = (token) => GetTokenPriceGrouped_1.default.get({
            origin: this.origin,
            dataset: this.dataset,
            setId: token,
            apiKey: this.apiKey,
        });
        this.getTokenPriceLive = (token) => (0, rxjs_1.from)(GetTokenPriceGroupedLive_1.default.get({
            origin: this.origin,
            dataset: this.dataset,
            setId: token,
            apiKey: this.apiKey,
        })).pipe((0, rxjs_1.switchMap)((inner) => inner), (0, rxjs_1.map)((r) => r || { id: token, price: 0, usdPrice: 0 }));
        this.getTokenPriceInUsd = async (token) => {
            const url = this.origin + interfaces_1.ApiRoutes.GET_TOKEN_PRICE;
            const response = await (0, fetch_utils_1.wrappedFetch)(this.origin, url, { token });
            return response.usdPrice;
        };
        this.getBidsLive = (token, type, status, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['token', 'type', 'status'],
                fieldValue: [token, type, status],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['price'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getMemberBidsLive = (token, member, type, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['token', 'owner', 'type'],
                fieldValue: [token, member, type],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.TokenMarketDataset = TokenMarketDataset;
